import { ReactNode } from 'react';
import { Link } from '@remix-run/react';
import { Logo } from '~/modules/theme/components/ui/Logo';
import { ResponseStatusAlert } from '~/modules/common/components/response-status-alert/ResponseStatusAlert';
import { useTranslation } from 'react-i18next';

export interface CenteredPageHeaderProps {
  children?: ReactNode;
  title?: string;
}

export const CenteredPageHeader = ({
  children,
  title,
}: CenteredPageHeaderProps) => {
  const { t } = useTranslation('common');
  const defaultTitle = t('global.title');
  return (
    <div className="flex flex-col text-center items-center gap-2">
      <div className="mb-4">
        <ResponseStatusAlert />
      </div>
      <Link to="/" className="flex flex-col items-center gap-2 font-medium">
        <Logo className="h-16 w-16" />
      </Link>
      <h1 className="text-xl font-bold">{title ?? defaultTitle}</h1>
      {children}
    </div>
  );
};
